import React, { Component, Fragment } from 'react';

import { Switch, Route, withRouter } from 'react-router-dom';
import API from '../../utils/API';
import ViewsContainer from '../../components/views/ViewsContainer';
import LoadingWizard from '../../components/spinner/wizard';
import BasicSectionHeader from '../../components/views/BasicSectionHeader';
import Request from './request';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import InputField from '../../components/inputs/inputField';
import NewCalendarModal from './modals/newCalendarModal';
import Calendar from './calendar';
class ProgramCalendars extends Component {
	constructor(props) {
		super(props);

		let fieldColumns = {
			name: 'Calendar Name',
			active: 'Active',
			bookings: 'Bookings',
			availability: 'Availability'
		};

		let fieldTypes = {
			name: 'text',
			active: 'boolean',
			bookings: 'number',
			availability: 'number'
		};
		const fieldCategories = {
			basics: {
				title: 'Basics',
				columns: [
					'name',
					'active',
					'bookings',
					'availability',
				]
			},
		};

		/* fieldColumns = { ...fieldColumns, ...props.program.fieldLabels };
		fieldTypes = { ...fieldTypes, ...props.program.fieldTypes }; */

		const formattedFieldColumns = {};
		const formattedFieldTypes = {};
		Object.keys(fieldColumns).forEach((key) => {
			if (key.includes('-')) {
				const shortKeys = key.split('-');
				const shortKey = shortKeys[shortKeys.length - 1];
				formattedFieldColumns[shortKey] = fieldColumns[key];
				formattedFieldTypes[shortKey] = fieldTypes[key];
			} else {
				formattedFieldColumns[key] = fieldColumns[key];
				formattedFieldTypes[key] = fieldTypes[key];
			}
		});
		this.state = {
			categoryColumns: fieldCategories,
			programId: props.program._id,
			calendars: props.calendars.map((c) => {
				return {
					...c,
					link: `/${props.orgId}/programs/${props.program._id}/calendars/${c._id}`
				};
			}),
			requestViews: props.calendarViews,
			loading: false,
			columns: formattedFieldColumns,
			columnTypes: formattedFieldTypes,
			deletedRequests: [],
			addModalOpen: false
		};
	}

	addCalendar = (calendar, cb) => {
		this.props.addCalendar(calendar, (c) => {
			const { calendars } = this.state;
			calendars.push(c);
			this.setState({ calendars: calendars });
			cb && cb()
		});
	}

	toggleAddModal = () => {
		this.setState({
			addModalOpen: !this.state.addModalOpen
		});
	}

	render() {
		const { program, orgId } = this.props;
		const { requestViews, categoryColumns, columns, calendars, columnTypes, addModalOpen } = this.state;
		return (
			<Switch>
				<Route exact path={`/${orgId}/programs/${program._id}/calendars`}>
					<Fragment>
						<ViewsContainer
							categoryColumns={categoryColumns}
							views={requestViews}
							entries={calendars}
							columns={columns}
							columnTypes={columnTypes}
							title="Calendars"
							subtitle={null}
							readOnly={false}
							mainActions={[
								{ type: 'button', onClick: this.toggleAddModal, label: 'Add Calendar' },
							]}
							batchActions={[]}
							enableDownloadViews={true}
							orgId={this.props.orgId}
							type={'ProgramCalendar'}
							referenceCollection={'Program'}
							referenceId={program._id}
							addedEntries={[]}
							breadcrumbs={[
								{
									name: program.name
								}
							]}
						/>
						{addModalOpen && <NewCalendarModal
							addCalendar={this.addCalendar}
							isOpen={addModalOpen}
							toggle={this.toggleAddModal}
						/>}
					</Fragment>
				</Route>
				<Route path={`/${orgId}/programs/${program._id}/calendars/:calendarId`}>
					<Calendar
						program={program}
						calendars={calendars}
						orgId={this.props.orgId}
						saveCalendar={this.props.saveCalendar}
					/>
				</Route>
			</Switch>
		);
	}
}

export default withRouter(ProgramCalendars);
